<template>
  <div :class="columnClassName">
    <column-header v-if="showColumnHeader" :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
				<div class="col-md-12">
          <h3 v-if="isPin">{{ _('PIN code') }}<template v-if="lockName">, {{ lockName }}</template><template v-if="this.action.code"> ({{ this.action.code }})</template></h3>
          <h3 v-if="isSmartDevice">{{ _('Smart Device Action') }}</h3>
        </div>
      </div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition name="fade" mode="out-in">
          <div v-bind="tabPanel('general')" class="tab-pane active" id="general" v-if="isTabActive('general')" key="general">
            <template v-if="isTemperature">
              <div class="row">
                <div class="col-sm-6">
                  <div :class="'panel panel-' + temperatureClass">
                    <div class="panel-heading">{{ _('Operation') }}</div>
                    <div class="panel-body">
                      <label><i :class="'fa fa-fw fa-' + temperatureIcon"></i> {{ DateTime.fromSeconds(Number(action.ts), { zone: timezone }).toFormat(dateFormat + " '" + _('at') + "' " + timeFormat) }}</label>
                      <p v-if="temperatureOperation"><i class="fa fa-fw fa-thermometer"></i> <span v-html="temperatureOperation"></span></p>
                      <p v-if="action.error" style="color: red">{{ action.error }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="isPin">
              <div class="row">
                <div class="col-sm-6">
                  <h4>{{ _('PIN code validity') }}</h4>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div :class="'panel panel-' + pinStartClass">
                    <div class="panel-heading">{{ _('Start of validity') }}</div>
                    <div class="panel-body">
                      <label><i :class="'fa fa-fw fa-' + pinStartIcon"></i> {{ DateTime.fromSeconds(Number(action.start_ts), { zone: timezone }).toFormat(dateFormat + " '" + _('at') + "' " + timeFormat) }}</label>
                      <p v-if="action.error" style="color: red">{{ action.error }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div :class="'panel panel-' + pinEndClass">
                    <div class="panel-heading">{{ _('End of validity') }}</div>
                    <div class="panel-body">
                      <label><i :class="'fa fa-fw fa-' + pinStartIcon"></i> {{ DateTime.fromSeconds(Number(action.end_ts), { zone: timezone }).toFormat(dateFormat + " '" + _('at') + "' " + timeFormat) }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="row">
              <div class="col-sm-6 leftcol" v-if="reservation && reservation.id">
                <h4>{{ _('Reservation') }} {{ reservation.id }}</h4>
                <h5>{{ reservationRange }}</h5>
              </div>
              <div class="col-sm-6 rightcol" v-if="resource && resource.id">
                <h4>{{ _('Resource') }} {{ resource.id }}</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 leftcol" v-if="reservation && reservation.id">
                <div class="form-group">
                  <label for="client_name">{{ _('Customer') }}</label>
                  <input id="clientTitle" disabled="disabled" class="form-control" name="client_name" type="text" v-model="reservation.client_name" />
                </div>
                <div class="form-group">
                  <label for="client_company">{{ _('Company') }}</label>
                  <input id="clientCompany" disabled="disabled" class="form-control" name="client_company" type="text" v-model="reservation.client_company" />
                </div>
                <div class="form-group">
                  <label for="client_email">{{ _('Email') }}</label>
                  <input id="clientEmail" disabled="disabled" class="form-control" name="client_email" type="email" v-model="reservation.client_email" />
                </div>
                <div class="form-group">
                  <label for="client_phone">{{ _('Telephone') }}</label>
                  <input id="clientPhone" disabled="disabled" class="form-control" name="client_phone" type="text" v-model="reservation.client_phone" />
                </div>
                <button type="button" class="btn btn-info" v-on:click="displayReservation(reservation)"><i class="fa fa-fw fa-calendar"></i> {{ _('Display reservation') }}</button>
              </div>
              <div class="col-sm-6 rightcol" v-if="resource && resource.id">
                <div class="form-group">
                  <label for="name">{{ _('Name') }}</label>
                  <input type="text" disabled="disabled" class="form-control" id="deviceName" v-model="resource.name">
                </div>
                <button type="button" class="btn btn-info" v-on:click="displayResource(resource)"><i class="fa fa-fw fa-cube"></i> {{ _('Display resource') }}</button>
              </div>
            </div>
            <div class="row" v-if="device && device.id">
              <div class="col-sm-6 leftcol">
                <h4 v-if="isPin">{{ _('Lock') }}</h4>
                <h4 v-if="isSmartDevice">{{ _('Smart Device') }}</h4>
                <div class="form-group">
                  <label for="name">{{ _('Name') }}</label>
                  <input type="text" disabled="disabled" class="form-control" id="deviceName" v-model="device.name">
                </div>
                <div class="form-group">
                  <label for="name">{{ _('Identifier') }}</label>
                  <input type="text" disabled="disabled" class="form-control" id="deviceIdentifier" v-model="device.identifier">
                </div>
                <button type="button" class="btn btn-info" v-on:click="displaySmartDevice(device)"><i :class="'fa fa-fw fa-' + deviceTypeIcon"></i> {{ _('Display smart device') }}</button>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <nav class="save-bar">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button class="btn btn-default" type="button" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import components from '~/lib/components'
import notifications from '~/lib/notifications'

export default {
  data () {
    return {
      action: {},
      kind: null,
      DateTime: DateTime
    }
  },
  mixins: [components, notifications],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'general', label: this._('General') }
      ])
    },
    ...mapGetters(['baseDomain', 'shopId', 'version', 'locale']),
    isPin () {
      return this.kind === 'pin'
    },
    isSmartDevice () {
      return this.kind === 'smartdevice'
    },
    isTemperature () {
      return this.isSmartDevice && this.device.type === 'temperature'
    },
    device () {
      return this.action && this.action.smartdevice ? this.action.smartdevice : {}
    },
    resource () {
      return this.action && this.action.resource ? this.action.resource : {}
    },
    reservation () {
      return this.action && this.action.reservation ? this.action.reservation : {}
    },
    temperatureOperation () {
      if (this.action.data) {
        try {
          const data = JSON.parse(this.action.data)
          return this._('Set temperature to %s').replace('%s', data.temperature + ' &#8451;')
        } catch(e) {}
      }
      return ''
    },
    temperatureClass () {
      return this.getPanelClass(this.temperatureIcon)
    },
    pinStartClass () {
      return this.getPanelClass(this.pinStartIcon)
    },
    pinEndClass () {
      return this.getPanelClass(this.pinEndIcon)
    },
    temperatureIcon () {
      if (!this.action) {
        return ''
      }
      if (DateTime.fromSeconds(Number(this.action.ts), { zone: this.timezone }) > DateTime.now({ zone: this.timezone })) {
        return 'clock'
      }
      if (!parseInt(this.action.performed) || this.action.error) {
        return 'exclamation-triangle'
      }
      return 'check'
    },
    pinStartIcon () {
      if (!this.action) {
        return ''
      }
      if (DateTime.fromSeconds(Number(this.action.start_ts), { zone: this.timezone }) > DateTime.now({ zone: this.timezone })) {
        return 'clock'
      }
      if (this.action.error) {
        return 'exclamation-triangle'
      }
      return 'check'
    },
    pinEndIcon () {
      if (!this.action) {
        return ''
      }
      if (DateTime.fromSeconds(Number(this.action.end_ts), { zone: this.timezone }) > DateTime.now({ zone: this.timezone })) {
        return 'clock'
      }
      if (this.action.error) {
        return 'exclamation-triangle'
      }
      return 'check'
    },
    reservationRange () {
      if (!this.reservation) {
        return ''
      }
      const startDate = DateTime.fromSeconds(Number(this.reservation.start_ts), { zone: this.timezone }).toJSDate()
      const endDate = DateTime.fromSeconds(Number(this.reservation.end_ts), { zone: this.timezone }).toJSDate()
      const startTime = DateTime.fromSeconds(Number(this.reservation.start_ts), { zone: this.timezone }).toFormat(this.timeFormat)
      const endTime = DateTime.fromSeconds(Number(this.reservation.end_ts), { zone: this.timezone }).toFormat(this.timeFormat)
      return DateTime.fromJSDate(startDate, { zone: this.timezone }).toFormat(this.dateFormat) + ' ' + this._('at') + ' ' + startTime + ' - ' + (DateTime.fromJSDate(endDate, { zone: this.timezone }).toFormat('yyyy-MM-dd') != DateTime.fromJSDate(startDate, { zone: this.timezone }).toFormat('yyyy-MM-dd') ? DateTime.fromJSDate(endDate, { zone: this.timezone }).toFormat(this.dateFormat) + ' ' + this._('at') + ' ' : '') + endTime
    },
    lockName () {
      return this.action && this.action.smartdevice ? this.action.smartdevice.name : null
    },
    deviceTypeIcon () {
      if (!this.device) {
        return ''
      }
      switch (this.device.type) {
        case 'lock':
          return 'lock'
        case 'temperature':
          return 'temperature-list'
      }
      return 'house-signal'
    },
    deviceSubType () {
      if (!this.device) {
        return ''
      }
      switch (this.device.subtype) {
        case 'adax':
          return this._('Adax')
        case 'yale':
          return this._('Yale')
        case 'ratna':
          return this._('Ratna')
        case 'igloo':
          return this._('Igloohome')
      }
      return this.device.subtype
    }
  },
  methods: {
    getPanelClass (icon) {
      switch (icon) {
        case 'clock':
          return 'info'
        case 'exclamation-triangle':
          return 'danger'
        case 'check':
          return 'success'
        default:
          return 'default'
      }
    },
    displayResource (resource) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'ResourceDetails',
        title: this._('Resource') + ' ' + resource.id + (resource.name ? ': ' + resource.name : ''),
        width: 6,
        data: {
          resourceId: resource.id,
          trail: this.componentTrail
        }
      })
    },
    displayReservation (reservation) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'ReservationDetails',
        title: this._('Reservation') + ' ' + reservation.id + (reservation.client_name ? ': ' + reservation.client_name : ''),
        width: 6,
        data: {
          reservationId: reservation.id,
          trail: this.componentTrail
        }
      })
    },
    displaySmartDevice (device) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'SmartDeviceDetails',
        title: this._('Smart Device') + ' ' + device.id + (device.name ? ': ' + device.name : ''),
        width: 6,
        data: {
          deviceId: device.id,
          trail: this.componentTrail
        }
      })
    },
    loadSmartDeviceAction (id, kind) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/smartdeviceactions/' + id + '.json?kind=' + kind + '&apikey=' + this.apiKey)
        } catch (e) {
          this.showError(e)
          reject()
          this.loading = false
          return
        }
        this.action = response.data
        this.kind = kind
        this.storeState()
        this.loading = false
        resolve(this.action)
      })
    },
  },
  created () {
    if (this.component && this.component.initData) {
      this.loadSmartDeviceAction(this.component.initData.actionId, this.component.initData.actionKind)
    }
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['smartdeviceactionUpdate'] = async (message) => {
        if (message && message.data && this.action && parseInt(message.data.id, 10) === parseInt(this.action.id, 10)) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            this.loadSmartDeviceAction(message.data.id, 'smartdevice')
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.action && this.action.id && parseInt(this.action.id, 10) !== parseInt(this.component.initData.actionId, 10) && this.component.initData.actionKind) {
        try {
          await this.loadSmartDeviceAction(this.component.initData.actionId, this.component.initData.actionKind)
        } catch(e) {}
      }
    }
  }
}
</script>